import { gql } from '@apollo/client';
import client from '../Store/storeApolloClient';

// Query matching your actual Hygraph schema
const GET_SPONSORS = gql`
  query GetSponsors {
    sponsors {
      id
      brandName
      logo {
        url
      }
      link
      altText
      startDate
      endDate
    }
  }
`;

export const fetchSponsors = async () => {
  try {
    const result = await client.query({
      query: GET_SPONSORS,
      fetchPolicy: 'cache-first'
    });
    
    if (result.data && result.data.sponsors) {
      const sponsors = result.data.sponsors;
      
      if (sponsors && sponsors.length > 0) {
        // Filter sponsors based on current date
        const currentDate = new Date();
        const activeSponsors = sponsors.filter(sponsor => {
          if (!sponsor.startDate || !sponsor.endDate) {
            return true; // Show sponsors without date restrictions
          }
          const startDate = new Date(sponsor.startDate);
          const endDate = new Date(sponsor.endDate);
          return currentDate >= startDate && currentDate <= endDate;
        });

        return activeSponsors;
      }
    }
    
    // No sponsors data found
    return [];
  } catch (error) {
    console.error('Error fetching sponsors:', error);
    return [];
  }
};
